// extracted by mini-css-extract-plugin
export default {"leaguePage":"LeaguePage_leaguePage__dN7yt","content":"LeaguePage_content__NbmjQ"};